export enum UtilityServiceErrorCode {
  GENERAL,
}

export enum UtilityPages {
  UnicodeToLatin = 'unilat6',
  CollateralManagementSession = 'CMSession',
}

export interface UnicodeToLatinServerData {
  Text: string
}

export interface CollateralManagementServerData {
  CMSessionID: number
  HashSum_CMSessionID_: string
}
